<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div id="square-container" [innerHTML]='"copy.html.FIBPacking.FIBPackingCopy"|copy|async'></div>
    </div>
</div>